function MFRSliderType1(index, element) {
  this.$element = $(element)

  this.selectors = {
    slider: ".slider",
    sliderPrevButton: ".flckty-prev",
    sliderNextButton: ".flckty-next",
    sliderMobile: ".mobile-details"
  }

  this.init()
}

MFRSliderType1.prototype = Object.assign({}, MFRSliderType1.prototype, {
  init: function () {
    this.$slider = this.$element.find(this.selectors.slider)
    this.$sliderPrevButton = this.$element.find(this.selectors.sliderPrevButton)
    this.$sliderNextButton = this.$element.find(this.selectors.sliderNextButton)
    this.$sliderMobile = this.$element.find(this.selectors.sliderMobile)
    
    $(window).on("load", this.__handleSliderInit.bind(this))
    $(window).on("resize", this.__handleSliderInit.bind(this))

    this.$sliderPrevButton.on("click", this.__handleSliderChange.bind(this))
    this.$sliderNextButton.on("click", this.__handleSliderChange.bind(this))
  },

  __handleSliderInit: function() {
    this.$slider.flickity({
      pageDots: false,
      contain: true,
      groupCells: true
    })

    this.__handleSliderMobileNavigation()
  },

  __handleSliderChange: function(event) {
    const currentTargetEvent = $(event.currentTarget).data('event')
    this.$slider.flickity(currentTargetEvent)
  },

  __handleSliderMobileNavigation: function(event) {
    const slidesLength = this.$slider.data('flickity').slides.length - 1
    const $mobileNextButton = this.$sliderMobile.find(this.selectors.sliderNextButton)
    const $mobilePrevButton = this.$sliderMobile.find(this.selectors.sliderPrevButton)

    this.$slider.on('change.flickity', function(event, index) {
      index == 0 ? $mobilePrevButton.addClass('disable') : $mobilePrevButton.removeClass('disable')
      index == slidesLength ? $mobileNextButton.addClass('disable') : $mobileNextButton.removeClass('disable')
    })

    $mobilePrevButton.addClass('disable')
  }
})